// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__10ZZ-","title":"FrontImage_title__1qMYF"};